var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMediaViewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-f1cd6a1e-5459-4ca0-9963-cd1d3de771ef",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "uuid-585b0c5b-569d-4dc5-8f96-e6a5f56e5e1e"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33,34H1c-.55273,0-1-.44727-1-1V1C0,.44727,.44727,0,1,0H33c.55273,0,1,.44727,1,1V33c0,.55273-.44727,1-1,1Zm-31-2h30V2H2v30Z",
    style: {
      fill: "#1a1a1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,23.33301H1c-.55273,0-1-.44727-1-1s.44727-1,1-1H33c.55273,0,1,.44727,1,1s-.44727,1-1,1Z",
    style: {
      fill: "#1a1a1a"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaViewIcon);
export default __webpack_public_path__ + "static/media/mediaViewIcon.75360d418223dd59454e0840233439d6.svg";
export { ForwardRef as ReactComponent };